import { render, staticRenderFns } from "./ColorInfo.vue?vue&type=template&id=1f776e53&scoped=true&"
import script from "./ColorInfo.vue?vue&type=script&lang=js&"
export * from "./ColorInfo.vue?vue&type=script&lang=js&"
import style0 from "./ColorInfo.vue?vue&type=style&index=0&id=1f776e53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f776e53",
  null
  
)

export default component.exports